export default {
  AccCode: "",
  Description: "",
  Description2: "",
  Nature: "",
  Type: "",
  Active: true,
  UseInAp: true,
  UseInAr: true,
  UseInGl: true,
  UseInAsset: true,
  UserModified: localStorage.getItem("UserName"),
  ReverseSign: false,
};
